"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* 依赖的模块，在这里统一引入，方便打包优化 */
var color_util_1 = require("@antv/color-util");
exports.colorUtil = color_util_1.default;
// 只引入框架，不引入内容
var scale_1 = require("@antv/scale");
exports.registerScale = scale_1.registerScale;
exports.getScale = scale_1.getScale;
exports.Scale = scale_1.Scale;
var adjust_1 = require("@antv/adjust");
exports.registerAdjust = adjust_1.registerAdjust;
exports.getAdjust = adjust_1.getAdjust;
exports.Adjust = adjust_1.Adjust;
var coord_1 = require("@antv/coord");
exports.getCoordinate = coord_1.getCoordinate;
exports.Coordinate = coord_1.Coordinate;
var attr_1 = require("@antv/attr");
exports.getAttribute = attr_1.getAttribute;
exports.Attribute = attr_1.Attribute;
//# sourceMappingURL=dependents.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/dependents.js
// module id = 345
// module chunks = 37